const dataLayer = () => window._sr;

export default {
  get: () => dataLayer(),
};
